import { render, staticRenderFns } from "./notice_privacy.vue?vue&type=template&id=2ca83dee&scoped=true&"
import script from "./notice_privacy.vue?vue&type=script&lang=js&"
export * from "./notice_privacy.vue?vue&type=script&lang=js&"
import style0 from "./notice_privacy.vue?vue&type=style&index=0&id=2ca83dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca83dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
